/* vf-autoplay.js — auto-move for sliders marked data-vf-autoplay="<seconds>" (sections/image-cards.liquid setting).
   Desktop: Hyper's Swiper instance (el.swiper) -> next slide, back to the first at the end.
   Mobile (swipe-mobile, native scroll): scroll one card, back to the start at the end; RTL aware.
   Pauses while hovered/touched/focused, off-screen or in a hidden tab; stops for good after the visitor swipes or
   uses the arrows; never runs with prefers-reduced-motion. */
(function () {
  'use strict';
  var W = window;
  if (W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function init(el) {
    if (el.vfAuto) return;
    el.vfAuto = true;
    var ms = Math.max(1.5, +el.getAttribute('data-vf-autoplay') || 2) * 1000;
    var paused = false, stopped = false, visible = true, auto = false;
    var rtl = getComputedStyle(el).direction === 'rtl';

    function scroller() { return el.classList.contains('swipe-mobile') && el.scrollWidth > el.clientWidth + 2 ? el : null; }
    function step() {
      if (paused || stopped || !visible || document.hidden) return;
      auto = true;
      var sw = el.swiper;
      if (sw && !sw.destroyed && sw.enabled !== false && W.innerWidth >= 768) {
        if (sw.isEnd) sw.slideTo(0, 900); else sw.slideNext(650);
      } else {
        var sc = scroller();
        if (sc) {
          var item = sc.querySelector('.swipe-mobile__inner > *');
          var w = item ? item.getBoundingClientRect().width + 8 : sc.clientWidth * 0.7;
          var atEnd = Math.abs(sc.scrollLeft) >= sc.scrollWidth - sc.clientWidth - 4;
          if (atEnd) sc.scrollTo({ left: 0, behavior: 'smooth' });
          else sc.scrollBy({ left: rtl ? -w : w, behavior: 'smooth' });
        }
      }
      setTimeout(function () { auto = false; }, 900);
    }
    var timer = setInterval(step, ms);

    function pause() { paused = true; }
    function resume() { paused = false; }
    function stop() { if (!auto) { stopped = true; clearInterval(timer); } }
    el.addEventListener('mouseenter', pause);
    el.addEventListener('mouseleave', resume);
    el.addEventListener('focusin', pause);
    el.addEventListener('focusout', resume);
    el.addEventListener('touchstart', function () { pause(); stop(); }, { passive: true });
    el.addEventListener('wheel', stop, { passive: true });
    var box = el.closest('.section__content') || el.parentNode;
    box.addEventListener('click', function (e) { if (e.target.closest('.swiper-button, .swiper-pagination')) stop(); });
    if ('IntersectionObserver' in W) {
      new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }, { threshold: 0.3 }).observe(el);
    }
  }

  function all() { [].forEach.call(document.querySelectorAll('[data-vf-autoplay]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
